import { createApp } from 'vue'
import App from './App.vue'

import print from 'vue3-print-nb'

// 引入 element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// --- ResizeObserver 良性通知抑制（必须早于任何组件挂载）---
// el-table 列宽自适应等场景下，RO 回调可能超出一帧预算，浏览器会抛出
// "ResizeObserver loop completed with undelivered notifications"。
// 该通知不影响布局与功能，对回调做防抖 + rAF 包装从根源上消除告警。
const debouncedROCallback = (callback) => {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      window.requestAnimationFrame(() => callback(...args))
    }, 20)
  }
}
const OriginalResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super(debouncedROCallback(callback))
  }
}

const app = createApp(App)
app.use(print)
app.use(ElementPlus)
// 配置 compilerOptions.isCustomElement
app.config.compilerOptions.isCustomElement = (tag) => {
    return tag === 'font'; // 告诉 Vue 将 <font> 视为原生元素
};
app.mount('#app')
